module.exports = __webpack_public_path__ + "static/media/bnl-logo.eadf178d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bnl-logo.svg
// module id = 2008
// module chunks = 0